var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Taxonomies", path: { name: "admin-taxonomies" } }],
          name: "Non-METRC Taxonomy",
          "no-title": "",
        },
      }),
      _vm._v(" "),
      _c(
        "b-alert",
        { staticClass: "py-2", attrs: { show: "", variant: "info" } },
        [
          _vm._v(
            "\n    Archived categories are excluded from product assignment, marketplace filters, search, and normal category resources.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { title: "Non-METRC Taxonomy" },
          scopedSlots: _vm._u([
            {
              key: "header-right",
              fn: function () {
                return [
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "mr-3 mt-1",
                      attrs: { switch: "" },
                      model: {
                        value: _vm.includeArchived,
                        callback: function ($$v) {
                          _vm.includeArchived = $$v
                        },
                        expression: "includeArchived",
                      },
                    },
                    [_vm._v("\n        Include archived\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        variant: "outline-secondary",
                        disabled: _vm.loading,
                      },
                      on: { click: _vm.loadAll },
                    },
                    [_vm._v("\n        Refresh\n      ")]
                  ),
                  _vm._v(" "),
                  _vm.activeTabIndex === 0
                    ? _c(
                        "no-permission-wrapper",
                        { attrs: { show: !_vm.canCreateTaxonomies } },
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                variant: "success",
                                disabled: !_vm.canCreateTaxonomies,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openCategoryModal()
                                },
                              },
                            },
                            [_vm._v("Add Category")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeTabIndex === 1
                    ? _c(
                        "no-permission-wrapper",
                        { attrs: { show: !_vm.canCreateTaxonomies } },
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                variant: "success",
                                disabled: !_vm.canCreateTaxonomies,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openFacetValueModal()
                                },
                              },
                            },
                            [_vm._v("Add Facet Value")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeTabIndex === 2
                    ? _c(
                        "no-permission-wrapper",
                        { attrs: { show: !_vm.canCreateTaxonomies } },
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                variant: "success",
                                disabled: !_vm.canCreateTaxonomies,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openBrowseGroupModal()
                                },
                              },
                            },
                            [_vm._v("Add Browse Group")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "b-tabs",
            {
              attrs: { "content-class": "pt-3" },
              model: {
                value: _vm.activeTabIndex,
                callback: function ($$v) {
                  _vm.activeTabIndex = $$v
                },
                expression: "activeTabIndex",
              },
            },
            [
              _c(
                "b-tab",
                { attrs: { title: "Categories" } },
                [
                  _c("b-table", {
                    attrs: {
                      fields: _vm.categoryFields,
                      items: _vm.filteredCategories,
                      busy: _vm.loading,
                      "table-class": "text-nowrap",
                      responsive: "",
                      "show-empty": "",
                      "empty-text": "No non-METRC categories found.",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(name)",
                        fn: function (row) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "non-metrc-taxonomy__description-cell",
                              },
                              [
                                _c("div", { staticClass: "font-weight-bold" }, [
                                  _vm._v(_vm._s(row.item.name)),
                                ]),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      row.item.definition || "No definition"
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(state)",
                        fn: function (row) {
                          return [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  variant: row.item.is_archived
                                    ? "secondary"
                                    : "success",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      row.item.is_archived
                                        ? "Archived"
                                        : "Active"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(groups)",
                        fn: function (row) {
                          return [
                            _vm.countRelated(
                              row.item.browse_groups,
                              row.item.browse_group_ids
                            )
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.labels(
                                        row.item.browse_groups,
                                        "display_name"
                                      )
                                    )
                                  ),
                                ])
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("None"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "cell(facet_count)",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.countRelated(
                                    row.item.facet_values,
                                    row.item.facet_value_ids
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(product_assignment_count)",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.categoryProductCount(row.item)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (row) {
                          return [
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canUpdateTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      size: "sm",
                                      variant: "primary",
                                      disabled: !_vm.canUpdateTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openCategoryModal(row.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Edit")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !row.item.is_archived
                              ? _c(
                                  "no-permission-wrapper",
                                  { attrs: { show: !_vm.canDeleteTaxonomies } },
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "danger",
                                          disabled: !_vm.canDeleteTaxonomies,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmArchive(
                                              "category",
                                              row.item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Archive")]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "no-permission-wrapper",
                                  { attrs: { show: !_vm.canUpdateTaxonomies } },
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "success",
                                          disabled: !_vm.canUpdateTaxonomies,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.restore(
                                              "category",
                                              row.item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Restore")]
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Facet Values" } },
                [
                  _c("b-table", {
                    attrs: {
                      fields: _vm.facetValueFields,
                      items: _vm.filteredFacetValues,
                      busy: _vm.loading,
                      "table-class": "text-nowrap",
                      responsive: "",
                      "show-empty": "",
                      "empty-text": "No non-METRC facet values found.",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(facet_key)",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.facetDimensionLabel(row.item.facet_key)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(label)",
                        fn: function (row) {
                          return [
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(_vm._s(row.item.label)),
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(row.item.facet_key)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(state)",
                        fn: function (row) {
                          return [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  variant: row.item.is_archived
                                    ? "secondary"
                                    : "success",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      row.item.is_archived
                                        ? "Archived"
                                        : "Active"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(category_count)",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.countIds(row.item.category_ids)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (row) {
                          return [
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canUpdateTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      size: "sm",
                                      variant: "primary",
                                      disabled: !_vm.canUpdateTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openFacetValueModal(row.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Edit")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !row.item.is_archived
                              ? _c(
                                  "no-permission-wrapper",
                                  { attrs: { show: !_vm.canDeleteTaxonomies } },
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "danger",
                                          disabled: !_vm.canDeleteTaxonomies,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmArchive(
                                              "facet_value",
                                              row.item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Archive")]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "no-permission-wrapper",
                                  { attrs: { show: !_vm.canUpdateTaxonomies } },
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "success",
                                          disabled: !_vm.canUpdateTaxonomies,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.restore(
                                              "facet_value",
                                              row.item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Restore")]
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Browse Groups" } },
                [
                  _c("b-table", {
                    attrs: {
                      fields: _vm.browseGroupFields,
                      items: _vm.filteredBrowseGroups,
                      busy: _vm.loading,
                      "table-class": "text-nowrap",
                      responsive: "",
                      "show-empty": "",
                      "empty-text": "No non-METRC browse groups found.",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(display_name)",
                        fn: function (row) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "non-metrc-taxonomy__description-cell",
                              },
                              [
                                _c("div", { staticClass: "font-weight-bold" }, [
                                  _vm._v(_vm._s(row.item.display_name)),
                                ]),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      row.item.description || "No description"
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(state)",
                        fn: function (row) {
                          return [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  variant: row.item.is_archived
                                    ? "secondary"
                                    : "success",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      row.item.is_archived
                                        ? "Archived"
                                        : "Active"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(category_count)",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.countIds(row.item.category_ids)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (row) {
                          return [
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canUpdateTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      size: "sm",
                                      variant: "primary",
                                      disabled: !_vm.canUpdateTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openBrowseGroupModal(
                                          row.item
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Edit")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !row.item.is_archived
                              ? _c(
                                  "no-permission-wrapper",
                                  { attrs: { show: !_vm.canDeleteTaxonomies } },
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "danger",
                                          disabled: !_vm.canDeleteTaxonomies,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmArchive(
                                              "browse_group",
                                              row.item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Archive")]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "no-permission-wrapper",
                                  { attrs: { show: !_vm.canUpdateTaxonomies } },
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "success",
                                          disabled: !_vm.canUpdateTaxonomies,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.restore(
                                              "browse_group",
                                              row.item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Restore")]
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Archived Assignments" } },
                [
                  _c("b-table", {
                    attrs: {
                      fields: _vm.archivedAssignmentFields,
                      items: _vm.archivedCategories,
                      busy: _vm.loading,
                      "table-class": "text-nowrap",
                      responsive: "",
                      "show-empty": "",
                      "empty-text": _vm.includeArchived
                        ? "No archived category assignments found."
                        : "Enable Include archived to load archived assignments.",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(name)",
                        fn: function (row) {
                          return [
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(_vm._s(row.item.name)),
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(row.item.code)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(archived_at)",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatDate(row.item.archived_at)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(facet_assignments)",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.countRelated(
                                    row.item.facet_values,
                                    row.item.facet_value_ids
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(browse_group_assignments)",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.countRelated(
                                    row.item.browse_groups,
                                    row.item.browse_group_ids
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(product_assignments)",
                        fn: function (row) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.categoryProductCount(row.item)) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (row) {
                          return [
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canUpdateTaxonomies } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant: "success",
                                      disabled: !_vm.canUpdateTaxonomies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.restore("category", row.item)
                                      },
                                    },
                                  },
                                  [_vm._v("Restore")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.categoryModal.visible
        ? _c("admin-non-metrc-category-modal", {
            attrs: {
              visible: _vm.categoryModal.visible,
              category: _vm.categoryModal.record,
              "facet-values": _vm.facetValues,
              "browse-groups": _vm.browseGroups,
              "facet-dimensions": _vm.facetDimensions,
            },
            on: {
              cancel: _vm.closeCategoryModal,
              success: _vm.onCategorySaved,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.facetValueModal.visible
        ? _c("admin-non-metrc-facet-value-modal", {
            attrs: {
              visible: _vm.facetValueModal.visible,
              "facet-value": _vm.facetValueModal.record,
              "facet-dimensions": _vm.facetDimensions,
            },
            on: {
              cancel: _vm.closeFacetValueModal,
              success: _vm.onFacetValueSaved,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.browseGroupModal.visible
        ? _c("admin-non-metrc-browse-group-modal", {
            attrs: {
              visible: _vm.browseGroupModal.visible,
              "browse-group": _vm.browseGroupModal.record,
            },
            on: {
              cancel: _vm.closeBrowseGroupModal,
              success: _vm.onBrowseGroupSaved,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }